import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/services/app-service.service';
@Component({
  selector: 'app-exam-footer',
  templateUrl: './exam-footer.component.html',
  styleUrls: ['./exam-footer.component.scss']
})
export class ExamFooterComponent implements OnInit {

  constants: any = [];
  footerText: any = '';
  contactPageObj:any = {};

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.contactPageObj = this.appService.getPageByKey('contact');
  }

  checkLogin() {
    return sessionStorage.getItem('loginId');
  }
}
